import React from "react";
import { Modal, Form, Button } from "react-bootstrap";

const EditComplaintModel = ({
  show,
  onHide,
  catForm,
  setCatForm,
  categoryMaster,
  subSuggestions,
  handleMainChange,
  submitCategoryUpdate,
  complaintData,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Main Category *</Form.Label>
          <Form.Select
            value={catForm.MainCategory}
            onChange={(e) => handleMainChange(e.target.value)}
          >
            <option value="">-- Select Main Category --</option>
            {categoryMaster.map(mc => (
              <option key={mc} value={mc}>{mc}</option>
            ))}
          </Form.Select>
          <Form.Text className="text-muted">
            Must exist in master list (CustomerComplaintMainCat).
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Sub Category</Form.Label>
          {/* text input with suggestions from existing data */}
          <Form.Control
            list="subcat-suggest"
            type="text"
            value={catForm.SubCategory}
            onChange={(e) => setCatForm(f => ({ ...f, SubCategory: e.target.value }))}
            placeholder="Type or pick a sub category"
          />
          <datalist id="subcat-suggest">
            {subSuggestions.map(s => <option key={s} value={s} />)}
          </datalist>
          <Form.Text className="text-muted">
            Optional. Suggestions come from existing complaints with the selected main category.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            id="logToAmsoft"
            label="Log complaint to AMSOFT system"
            checked={catForm.logToAmsoft || false}
            onChange={(e) => setCatForm(f => ({ ...f, logToAmsoft: e.target.checked }))}
          />
          <Form.Text className="text-muted">
            This will send the complaint data to AMSOFT system after updating the category.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={submitCategoryUpdate} disabled={!catForm.MainCategory}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditComplaintModel;
